import React from 'react';
import {Box, Button, Dialog, DialogActions, DialogContent, DialogTitle} from "@mui/material";
import OrderDatePicker from "../../../../datepicker/OrderDatePicker";
import ButtonExit from "../../../../button/ButtonExit";
import ButtonAdd from "../../../../button/ButtonAdd";

const ModalExecuteJob = ({
                             date,
                             setDate,
                             open,
                             onClose,
                             onExecute
                         }) => {

    return (
        <div>
            <Dialog open={open}>
                <DialogTitle textAlign="center">Выполнить</DialogTitle>
                <DialogContent>
                    <Box sx={{mt: '0.2rem'}}>
                        <OrderDatePicker
                            label="Дата оформления"
                            date={date}
                            setDate={setDate}
                        />
                    </Box>
                </DialogContent>
                <DialogActions sx={{p: '1.25rem'}}>
                    <ButtonExit text={"Выйти"} onClick={onClose}/>
                    <ButtonAdd text={"Выполнить"} onClick={onExecute}/>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default ModalExecuteJob;